import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import SnackbarComponent from '../../components/snackbar'
import * as common from '../../appRedux/actions/common'
import Backdrop from '../../components/backdrop'
import Drawer from './drawer'

function Layouts(props) {
    const history = useHistory()

    useEffect(() => {
        props.sendPushWelcomeAction()
        props.splashLoadingAction()
    }, [])

    useEffect(() => {
        if (props.redirect !== null) {
            history.push(props.redirectId ?
                {
                    pathname: props.redirect, search: '?id=' + props.redirectId,
                } : props.redirect)
            props.redirectAction(null)
        }
    }, [props.redirect])

    return (
        <React.Fragment>
            {props.backdrop ? <Backdrop /> : <Drawer />}
            <SnackbarComponent />
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        redirect: state.common.redirect,
        backdrop: state.common.backdrop ,
        redirectId: state.common.redirectId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (data) => dispatch(common.redirectAction(data)),
        splashLoadingAction: () => dispatch(common.splashLoadingAction()),
        sendPushWelcomeAction: () => dispatch(common.sendPushWelcomeAction()),
        snackbarAction: (status, message) => dispatch(common.snackbarAction(status, message))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layouts)
